import { EventEmitter } from 'events';
import * as Inovx from '@shared';

import DiagnosticsConstants from './../constants/DiagnosticsConstants';
var DateTimeFormatHelper = Inovx.Shared.Common.DateTimeFormatHelper;

var CHANGE_EVENT = 'diagnostics.change';

var _data: ILogMessage[] = [],
    //_dataMap is to prevent any duplicate entries inside _data
    _dataMap: any = {};

var _auditData: ILogMessage[] = [],
    _auditDataMap: any = {};


var _modalVisible: boolean = false;
var _diagnostic: any = null;

function fixData(data: ILogMessage[]) {
    if (data) {
        data.forEach((m) => {
            fixLogMessage(m);
        });
    }
}

function fixLogMessage(m: ILogMessage) {
    if (m) {
        const date = m.Date;
        m.Date = DateTimeFormatHelper.getFormatDate(date) + " " + DateTimeFormatHelper.getFormatTime(date, true);
        m.DateDisplay = DateTimeFormatHelper.getFormatDate(date);
        m.TimeDisplay = DateTimeFormatHelper.getFormatTime(date, true);
    }
}

var DiagnosticsStore: IDiagnosticsStore = Object.assign({}, EventEmitter.prototype, {
    // Add store getters here
    getData: function () {
        return _data;
    },
    getAuditData: function () {
        return _auditData;
    },
    getDiagnostic: function () {
        return _diagnostic;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback:any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload:any) {
    switch (payload.actionType) {
        case DiagnosticsConstants.GET_DATA:
            _dataMap = {};
            for (var i = 0; i < payload.data.length; i++) {
                _dataMap[payload.data[i]["MessageId"]] = null;
            }
            _data = payload.data;
            fixData(_data);
            break;
        case DiagnosticsConstants.GET_NEXT_DATA:
            for (var i = 0; i < payload.data.length; i++) {
                if (_dataMap[payload.data[i]["MessageId"]] !== null) {
                    _dataMap[payload.data[i]["MessageId"]] = null;
                    fixLogMessage(payload.data[i]);
                    _data.push(payload.data[i]);
                }
            }
            break;
        case DiagnosticsConstants.GET_AUDIT_DATA:
            _auditDataMap = {};
            for (var i = 0; i < payload.data.length; i++) {
                _auditDataMap[payload.data[i]["MessageId"]] = null;
            }
            _auditData = payload.data;
            fixData(_auditData);
            break;
        case DiagnosticsConstants.GET_NEXT_AUDIT_DATA:
            for (var i = 0; i < payload.data.length; i++) {
                if (_auditDataMap[payload.data[i]["MessageId"]] !== null) {
                    _auditDataMap[payload.data[i]["MessageId"]] = null;
                    fixLogMessage(payload.data[i]);
                    _auditData.push(payload.data[i]);
                }
            }
            break;
        case DiagnosticsConstants.DISPLAY_DIAGNOSTICS:
            _diagnostic = payload.diagnosticInformation;
            fixLogMessage(_diagnostic);
            _modalVisible = true;
            break;
        case DiagnosticsConstants.CLOSE_DIAGNOSTICS:
            _modalVisible = false;
            break;
        default: return true;
    }

    DiagnosticsStore.emitChange();

    return true;
});

export default DiagnosticsStore;
